import {util} from '@/utils/utils'
import {sessionUtil} from '@/utils/session.js'
/**
 * 获取验证码
 * @param params
 */
export const getVerificationCode = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restGet('/api_v1/corp/code', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
  return p
}


export const getRegisterCorp = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restGet('/api_v1/corp/list', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}

export const registerCorp = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restPost('/api_v1/corp/register', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}
export const registerUser = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restPost('/api_v1/corp/register/user', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}

/**
 * 完善用户信息
 * @param params
 * @returns {Promise<any>}
 */
export const improveUserInfo = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restPost('/api_v1/corp/improve/user', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}

export const removeData = (type) => {
  // let url = type === 1?'/api_v1/sys/clear/bus':(type === 2?'/api_v1/sys/clear/wf':'/api_v1/sys/clear/org')
  var p = new Promise(function (resolve, reject) {
    util.restDelete('/api_v1/sys/clear', {type:type}, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}
/**
 * 初始化01组织
 * @param params
 * @returns {Promise<any>}
 */
export const initCorp = (params) => {
  // let url = type === 1?'/api_v1/sys/clear/bus':(type === 2?'/api_v1/sys/clear/wf':'/api_v1/sys/clear/org')
  var p = new Promise(function (resolve, reject) {
    util.restPost('/api_v1/sys/corp/init', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res.errorMsg)
      }
    })
  })
  return p
}

/**
 * 登陆页面获取扫码相关参数
 * @param params
 */
export const getOauth2Info = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restGet('/api_v1/corp/oauth2/info', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
  return p
}

/**
 * 获取当前组织是否用同步微信同步的权限
 * 返回 orgToWx和wxToOrg两个boolean值
 * @returns {Promise<any>}
 */
export const getWxSyncAuth = () =>{
  return new Promise(function (resolve, reject) {
    let companyUid = sessionUtil.getCompanyUid()
    util.restGet('/api_v1/wx/sync/auth', {companyUid}, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
}

/**
 * 获取企业信息
 * @returns {Promise<any>}
 */
export const getOrgCorpInfo = (id) =>{
  return new Promise(function (resolve, reject) {
    util.restGet('/api_v1/org/corp/'+id, null, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
}


/**
 * 获取企业配置公共常量
 * @returns {Promise<any>}
 */
export const getCommonConf = () =>{
  return new Promise(function (resolve, reject) {
    util.restGet('/api_v1/corp/conf/common', null, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
}

export const getCorpLicense = () =>{
  return new Promise(function (resolve, reject) {
    let companyUid = sessionUtil.getCompanyUid()
    util.restGet('/api_v1/corp/license', {companyUid}, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject(res)
      }
    })
  })
}






// WEBPACK FOOTER //
// ./src/api/corp.js